export const FETCH_USERS_STARTED = 'FETCH_USERS_STARTED';
export const FETCH_USERS_COMPLETED = 'FETCH_USERS_COMPLETED';
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';

export const ADD_USER_STARTED = 'ADD_USER_STARTED';
export const ADD_USER_COMPLETED = 'ADD_USER_COMPLETED';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';

export const EDIT_USER_STARTED = 'EDIT_USER_STARTED';
export const EDIT_USER_COMPLETED = 'EDIT_USER_COMPLETED';
export const EDIT_USER_ERROR = 'EDIT_USER_ERROR';

export const DELETE_USER_STARTED = 'DELETE_USER_STARTED';
export const DELETE_USER_COMPLETED = 'DELETE_USER_COMPLETED';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

export const ADD_USERDETAIL_STARTED = 'ADD_USERDETAIL_STARTED';
export const ADD_USERDETAIL_COMPLETED = 'ADD_USERDETAIL_COMPLETED';

export const UPDATE_USER_STARTED = 'UPDATE_USER_STARTED';
export const UPDATE_USER_COMPLETED = 'UPDATE_USER_COMPLETED';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/userActionTypes.js